import { Button, Dialog, Icon, IconSizeClasses } from '@eppendorf/vnls-react-components';
import { t } from 'i18next';
import { ReactNode, useCallback, useRef } from 'react';

import { useAutoFocus } from '$shared/custom-hooks/useAutoFocus';

export interface SuccessDeleteDialogProps {
  title: string;
  description: ReactNode;
  isOpen?: boolean;
  onClose: () => void;
}

export function SuccessDeleteDialog({
  title,
  description,
  isOpen,
  onClose,
}: SuccessDeleteDialogProps) {
  const handleOpenChange = useCallback(
    (open: boolean) => {
      if (!open) {
        onClose();
      }
    },
    [onClose],
  );

  const closeButtonRef = useRef<HTMLButtonElement>(null);
  useAutoFocus(closeButtonRef);

  return (
    <Dialog
      isOpen={isOpen}
      onOpenChange={handleOpenChange}
      className="w-max-4xl"
      hideCloseButton
    >
      <div className="flex flex__dir--column flex__ai--center text-align-center">
        <Icon
          name="success"
          className="bg-green-500 m-bottom-xxl"
          size={IconSizeClasses.XLarge}
        />
        <Dialog.Title>{title}</Dialog.Title>
        <Dialog.Description />
        <div className="m-top-xxs">{description}</div>
      </div>
      <Dialog.Actions className="m-top-xxl">
        <Dialog.Close>
          <Button ref={closeButtonRef} className="btn--solid">
            {t('shared.close')}
          </Button>
        </Dialog.Close>
      </Dialog.Actions>
    </Dialog>
  );
}
